import { inject, injectable } from "inversify";
import { BudgetRepository } from "@project/data/repositories/budget.repository";

export interface EditJustificationTemplateInput {
    id: number;
    name: string;
    description?: string;
    version: number;
    visible: boolean;
    json_schema: any;
    template_key: string;
}

@injectable()
export class EditJustificationTemplateUseCase {
    constructor(
        @inject(BudgetRepository)
        private readonly budgetRepository: BudgetRepository,
    ) { }

    async execute(input: EditJustificationTemplateInput): Promise<boolean> {
        return this.budgetRepository.editJustificationTemplate(input);
    }
}
